<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="control-line mat-elevation-z8">
        <!-- Market (mat-select with in-panel search) -->
        <div class="filter-actions-line">
            <mat-form-field appearance="outline">
                <mat-label>Sites</mat-label>
                <mat-select id="siteSelect" data-testid="siteSelect" formControlName="siteId" name="site"
                    (selectionChange)="onSiteSelected($event.value)">
                    <div class="mat-select-search-container" (click)="$event.stopPropagation()">
                        <input #streamSearchInput matInput placeholder="Search Sites..."
                            (input)="onSiteSearchQuery($event)" class="mat-select-search-input"
                            aria-label="Search Sites" />
                        <mat-icon class="mat-select-search-icon">search</mat-icon>
                    </div>
                    <mat-option [value]=0>-Select Site-</mat-option>
                    @for (site of sitesFiltered(); track site.id) {
                    <mat-option [value]="site.id">{{ site.siteName }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <!-- Dynamic FormArray -->
    <div class="mar-top-20">
        <div *ngIf="siteLockCodesFormArray?.controls?.length" formArrayName="siteLockCodes" class="filter-actions-line">
            <div *ngFor="let fg of siteLockCodesFormArray.controls; let i = index" [formGroupName]="i"
                style="margin-bottom: 10px;">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label> <span class="rounded-label" [style.backgroundColor]="fg.get('colorCode')?.value">
                            {{ fg.get('tankName')?.value }}
                        </span></mat-label>
                    <input matInput formControlName="siteLockCode" class="input-box" id="siteLockCodeInput" type="tel"
                        data-testid="siteLockCodeInput" (input)="roundOff($event, 9999999999, 4, 0)" />
                </mat-form-field>
            </div>
            @if(controlPermissions.addButton){
                <button type="submit" mat-raised-button color="primary" align="end"
                    [disabled]="form.invalid || form.pristine">
                    Save
                </button>
            }

        </div>
    </div>

</form>